import React from 'react'
import { FormattedMessage } from 'react-intl'
import Panel from '../panel'
import OpenHome from './open_home'

export default function AuctionPanel({ property }) {
  const auction = property.attributes.settings?.auction

  if (!auction || !auction.start_date) {
    return null
  }

  return (
    <Panel title={<FormattedMessage id="open-homes.auction" />}>
      <OpenHome isAuction openHome={auction} propertyId={property.id} />
    </Panel>
  )
}
